import { Api } from '../api'

interface LogPayload {
  event_id: string
  order_id: string
  buyer_name: string
  recipient: string
  channel: 'email' | 'whatsapp'
  status: 'success' | 'failed'
  error_message?: string
}

export async function logCommunication(payload: LogPayload): Promise<void> {
  try {
    await Api.post.communicationLog({
      ...payload,
      triggered_by: 'store',
      sent_at: new Date().toISOString(),
    })
  } catch {
    // fire-and-forget — never affect purchase flow
  }
}
